exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gameoptions[data-v-863ea7c6]{margin-bottom:-2.6em;margin-top:.3em}", ""]);

// exports
